import { autoWebViewJs, ICallScriptRunnerResult, isRealInAndroid, Manifest } from "@droid/android";
import { Box, Button, Dialog, Modal, Paper, Stack, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
function getScript(){
    const script = `

var domain = {}
var smsEventType = "smsReceived";
var smsDispatcher = com.fanfanlo.lib.smstransfer.receiver.SmsReceiver.dispatcher;

function runAskPermissions(){
    com.fanfanlo.lib.utils.PermissionUtils.askPermissions(["${Manifest.Permission.RECEIVE_SMS}","${Manifest.Permission.READ_SMS}", "${Manifest.Permission.READ_PHONE_STATE}", "${Manifest.Permission.READ_PHONE_NUMBERS}", "${Manifest.Permission.READ_CALL_LOG}"], {
        onGranted:function(permissions, granted){
            if(granted){
                runScriptAfterHasPermissions();
            }
        },
        onDenied:function(permissions, doNotAskAgain){
        }
    });
}
runAskPermissions();

function runScriptAfterHasPermissions(){
    function onSmsReceived(data){
        java.lang.System.out.println("js sms received sender is " + data.sender + " sms is " + data.msg + " receive time is " + data.time + "receiver number is" + data.receiver + " slot is " + data.slot);
        sendMsm(data);
        sendMail(data);
    }
    smsDispatcher.addListener(smsEventType, onSmsReceived, false, domain);
}

function sendMsm(data){
    // var key = "57a60ecf-4c79-4b3d-b0ad-aa4e70e70d40:" + data.receiver ? data.receiver : "abc";
    var key = "${localStorage.getItem(nsMobilePathKey)}";
    if(!key || key == 'null'){
        return;
    }
    // var url = "https://d.shangwoa.top/redis-set-sms-upstash";
    var url = "${localStorage.getItem(nsSendSmsUrlKey)}";
    if(!url || url == 'null'){return;}
    var body = com.fanfanlo.lib.utils.JsonUtil.gson2.toJson({k:key, v:data});
    com.fanfanlo.lib.utils.UIThreadUtil.runInNewThread(function(){
        com.fanfanlo.lib.net.HttpUtils.post(url, body);
    });
}
    function sendMail(data){
    var to = "${localStorage.getItem(nsEmailKey)}";
    if(!to || to == 'null'){return;}
    var auth = "${localStorage.getItem(nsResendAuthKey)}";
    if(!auth || auth == 'null'){return;}
    java.lang.System.out.println("start send mail");
    var url = "${resendAipUrl}";
        if(!url || url == 'null'){return;}
        var body = {
            from: "onboarding@resend.dev",
            to: to,
            subject: String("new message from " + data.sender),
            html: String("<div><p>content:" + data.msg + "</p><p>from:" + data.sender + "</p><p>time:" + data.time + "</p><p>receiver:" + data.receiver + "</p><p>slot:" + data.slot + "</p></div>")
        };
        var header = {
            "Authorization": String("Bearer " + auth),
            "Content-Type": "application/json"
        }
        com.fanfanlo.lib.utils.UIThreadUtil.runInNewThread(function(){
            com.fanfanlo.lib.net.HttpUtils.post(url, body, header);
        });
        java.lang.System.out.println("end send mail");
    }
function onJavaCallTerminate(){
    smsDispatcher.removeDomainListeners(domain);
    return true;
}
`;
    return script;
}
const scriptId = 'fanfanlo/sms/listener/1';

const isRunningScript = `
// var data = com.fanfanlo.droidlib.auto.rhino.RhinoManager.isRunning("${scriptId}");
var data = com.fanfanlo.droidlib.auto.js.JsManager.isRunning("${scriptId}");

var res = com.fanfanlo.lib.utils.JsonUtil.gson2.toJson(data);

res;
`

const stopScript = `
// var data = com.fanfanlo.droidlib.auto.rhino.RhinoManager.stopById("${scriptId}");
var data = com.fanfanlo.droidlib.auto.js.JsManager.stopById("${scriptId}");
var res = com.fanfanlo.lib.utils.JsonUtil.gson2.toJson(data);
res;
`

function getScriptConf() {
    return {
        injects: ["console"],
        onlyRunSingle: true,
        stopPrevIfOnlyRunSingle: true,
        scriptId,
        script: getScript()
    }
}
interface IStopByIdResult {
    total: number
    stoped: number
}
let runnerResult: ICallScriptRunnerResult | undefined;
function testUrl(str: string) {
    const urlPattern = /^https?:\/\/[^\s/$.?#].[^\s]*$/i;
    if (!urlPattern.test(str)) {
        // console.log('not legal url', str);
        return '';
    }
    try {
        const u = new URL(str);
        const parts = u.hostname.split(".");
        // console.log(`u.hostname.split(".")`, u.hostname.split("."))
        if (
            parts.length < 2 ||
            parts.some(p => p.length === 0) ||
            parts[parts.length - 1].length < 2
        ) {
            // console.log('not legal url with .', str);
            return '';
        }
        return u.href;
    } catch (e) {
        // console.log('not legal url2', str);
        return '';
    }
}
function testResendAuth(auth: string) {
    if (auth.length < 4) return ''
    if (auth.indexOf('re_') != 0) return '';
    return auth;
}
function testEmail(email: string) {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return '';
    return email;
}
const ns = "@test";
const nsSendSmsUrlKey = `${ns}/sendSmsUrl`;
const nsResendUrlKey = `${ns}/resendUrl`;
const nsResendAuthKey = `${ns}/resendAuth`;
const nsEmailKey = `${ns}/email`;
const nsMobilePathKey = `${ns}/mobilePathKey`;

const readSmsUrl = "https://d.shangwoa.top/redis-lrange-get-upstash";
const resendAipUrl = "https://api.resend.com/emails";
const defSendSmsUrl = (()=>{
    if(typeof window === 'undefined')return '';
    let data = localStorage.getItem(nsSendSmsUrlKey);
    if (!data || data == 'null'){
        // data = "https://redis-set-sms-upstash.mailregios.workers.dev/";
        data = "https://d.shangwoa.top/redis-set-sms-upstash";
        localStorage.setItem(nsSendSmsUrlKey, data);
    }
    return data;
})();
const resendUrl = (()=>{
    if(typeof window === 'undefined')return '';
    let data = localStorage.getItem(nsResendUrlKey);
    if (!data || data == 'null'){
        data = "https://resend.com";
        localStorage.setItem(nsResendUrlKey, data);
    }
    return data;
})();
const defResendAuth = (()=>{
    if(typeof window === 'undefined')return '';
    let data = localStorage.getItem(nsResendAuthKey);
    if (!data || data == 'null'){
        data = "re_17h7y4J2_Jw88LxFtdJCfxomHhjtM44Y5";
        localStorage.setItem(nsResendAuthKey, data);
    }
    return data;
})();
const defEmail = "name@example.com";
const defMobilePathKey = (() => {
    if (typeof window == 'undefined') return '';
    let prefix = localStorage.getItem(nsMobilePathKey);
    if (!prefix || prefix == 'null') {
        prefix = uuidv4();
        localStorage.setItem(nsMobilePathKey, prefix);
    }
    return prefix;
})();
export function SmsScriptItemComponent() {
    const [isRunning, setIsRunning] = useState(false)
    const [openSetting, setOpenSetting] = useState(false)
    const [sendSmsUrl, setSendSmsUrl] = useState("");
    const [resendAuth, setResendAuth] = useState("");
    const [email, setEmail] = useState("");
    const [mobilePathKey, setMobilePathKey] = useState(defMobilePathKey);
    function callOpenSetting() {
        setOpenSetting(true);
        reloadSmsUrl();
        reloadResendAuth();
        reloadEmail();
    }
    function reloadSmsUrl() {
        const url = localStorage.getItem(nsSendSmsUrlKey) || defSendSmsUrl;
        // console.log('reloadSmsUrl', url);
        setSendSmsUrl(url);
    }
    function reloadResendAuth() {
        const auth = localStorage.getItem(nsResendAuthKey) || defResendAuth;
        // console.log('reloadResendAuth_fn', auth);
        setResendAuth(auth);
    }
    function reloadEmail() {
        const email = localStorage.getItem(nsEmailKey) || "";
        // console.log('reloadEmail_fn', email);
        setEmail(email);
    }
    useEffect(() => {
        reloadSmsUrl();
        reloadResendAuth();
        reloadEmail();
    }, [])

    function onMobilePathKeyChange(str: string) {
        setMobilePathKey(str);
        localStorage.setItem(nsMobilePathKey, str);
    }
    useEffect(() => {
        if (sendSmsUrl.length > 0) return;
        setTimeout(() => {
            // console.log('later check sendSmsUrl', sendSmsUrl);
            if (sendSmsUrl.length > 0) return;
            setSendSmsUrl(defSendSmsUrl)
        }, 1000 * 3)
    }, [sendSmsUrl]);
    function onSendSmsUrlChange(str: string) {
        setSendSmsUrl(str);
        if (str === "") {
            localStorage.removeItem(nsSendSmsUrlKey);
        }
        const href = testUrl(str);
        if (!href) return;
        console.log('save url', href);
        localStorage.setItem(nsSendSmsUrlKey, href);
    }
    useEffect(() => {
        if (resendAuth.length > 0) return;
        setTimeout(() => {
            // console.log('later check resendAuth', resendAuth);
            if (resendAuth.length > 0) return;
            setResendAuth(defResendAuth)
        }, 1000 * 3)
    }, [resendAuth])
    function onResendAuthChange(str: string) {
        setResendAuth(str);
        if (str === "") {
            localStorage.removeItem(nsResendAuthKey);
            return;
        }
        localStorage.setItem(nsResendAuthKey, str);
    }
    function onEmailChange(str: string) {
        setEmail(str);
        if (str === "") {
            localStorage.removeItem(nsEmailKey);
            return;
        }
        const email = testEmail(str);
        if (!email) return;
        localStorage.setItem(nsEmailKey, email);
    }
    useEffect(() => {
        if (email.length > 0) return;
        setTimeout(() => {
            // console.log('later check email', email);
            if (email.length > 0) return;
            // setEmail(defEmail)
        }, 1000 * 3)
    }, [email])
    const onRunScriptClick = async () => {
        const res = autoWebViewJs.callScriptByConf(getScriptConf())
        // console.log('FirstProjectButton call run script res is', res)
        runnerResult = res.javaResultData
        checkIsRunning()
    }
    const onStopClick = () => {
        console.log('stop project', scriptId)
        const res = autoWebViewJs.callScript<IStopByIdResult>(stopScript)
        // console.log('FirstProjectButton call onStopClick res is', res)
        checkIsRunning()
    }
    function checkIsRunning() {
        const res = autoWebViewJs.callScript<string>(isRunningScript)
        const isRun = !!res.javaResultData && res.javaResultData !== "false";
        // console.log('FirstProjectButton call isRunningScript res is', isRun, res)
        setIsRunning(isRun)
    }
    useEffect(() => {
        checkIsRunning()
    }, []);
    function onCfButtonClick(e: React.MouseEvent<HTMLAnchorElement>) {
        onUrlClick(e, "https://cloudflare.com/")
    }
    function onUpstashButtonClick(e: React.MouseEvent<HTMLAnchorElement>) {
        onUrlClick(e, "https://console.upstash.com/")
    }
    function onResendClick(e: React.MouseEvent<HTMLAnchorElement>) {
        onUrlClick(e, resendUrl);
    }
    function onUrlClick(e: React.MouseEvent<HTMLAnchorElement>, url: string) {
        if (!isRealInAndroid) return;
        e.stopPropagation();
        e.preventDefault();
        const script = `
        com.fanfanlo.lib.intent.Funcs.browserOpenUrl("${url}");`
        autoWebViewJs.callScript(script)
    }
    function onMobilePathKeyClick(e: React.MouseEvent<HTMLAnchorElement>) {
        onUrlClick(e, `${readSmsUrl}/?k=${mobilePathKey}`)
    }
    
    async function testSendEmail(){
        console.log('start testSendEmail')
        const url = localStorage.getItem(nsEmailKey);
        if (!url) return;
        // val sender:String, val msg:String, val time:Long, val receiver:String, val slot:Int
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                sender: '+15205309873',
                msg: 'test',
                time: Date.now(),
                receiver: '+15321167889',
                slot: 0,
            }),
        });
        const data = await res.json();
        console.log('testSendEmail complete', data);
    }
    async function testSendSms(){
        const url = `${sendSmsUrl}`;
        // val sender:String, val msg:String, val time:Long, val receiver:String, val slot:Int
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({k:mobilePathKey, v:{
                sender: '+15205309873',
                msg: 'test',
                time: Date.now(),
                receiver: '+15321167889',
                slot: 0,
            }}),
        });
        const data = await res.json();
        console.log('testSendSms complete', data);
    }
    async function onTestSendClick(){
        await testSendEmail();
        await testSendSms();
    }
    return (
        <>
            <Box>
                <span>转发短信</span>
                <span>{isRunning ? "运行中" : "未运行"}</span>
                <Button onClick={onRunScriptClick}>运行</Button>
                <Button onClick={onStopClick}>停止</Button>
                <Button onClick={() => callOpenSetting()}>设置</Button>
                <Dialog open={openSetting} onClose={() => setOpenSetting(false)}>
                    {/* <Paper> */}

                    <Stack sx={{ bgcolor: "background.paper", m: 1, p: 1, height: "100%" }} direction="column" spacing={2}>
                        <Box>
                            <span>设置</span>
                            <Button onClick={() => setOpenSetting(false)}>关闭</Button>
                            {((sendSmsUrl && mobilePathKey) ||testEmail(email))
                            && <Button onClick={onTestSendClick}>模拟接收到短信</Button>}
                            
                        </Box>
                        <Stack sx={{ border: "1px solid #ccc", borderRadius: 1, p: 1 }} direction={"column"}
                            spacing={1}>
                            <Box>
                                <span style={{color:"red"}}>强烈建议您使用自己的服务进行转发，如您懂些编程的话，请自行修改代码并进行加密发送信息。</span>
                            </Box>
                        </Stack>
                        <Stack sx={{ border: "1px solid #ccc", borderRadius: 1, p: 1 }} direction={"column"}
                            spacing={1}>
                            <Box>
                                <b>邮箱地址</b>
                            </Box>
                            <Box>
                                <span>不填写将不会发送邮件</span>
                            </Box>
                            <Box>
                                <TextField
                                    error={!!email && !testEmail(email)}
                                    id="editable-text"
                                    aria-label="editable-text"
                                    required
                                    fullWidth
                                    multiline
                                    placeholder={defEmail}
                                    helperText={!email ? "不填写将不会发送邮件" : testEmail(email) ? "请输入您要转发邮件的邮箱地址" : "您输入的邮箱地址可能不正确"}
                                    variant="standard"
                                    value={email} onChange={(e) => onEmailChange(e.target.value)} />
                            </Box>
                        </Stack>
                        <Stack sx={{ border: "1px solid #ccc", borderRadius: 1, p: 1 }} direction={"column"}
                            spacing={1}>
                            <Box>
                                <b>读取短信的路径</b>
                            </Box>
                            <Box>
                                <Box><span>不填写将不会把短信内容发送到远程服务器。</span></Box>
                                <Box>
                                    <span>
                                        该字符串可以起到轻微加密的作用，长度您可以设置在100个字符以内，建议30个字符以上。
                                    </span>
                                </Box>
                                <Box>
                                    <span>我们提供的默认存储并没有访问限制，任何人知道、猜到、枚举到路径都可以获取到您的短信内容，强烈建议您替换为您的安全方式接收和存储短信，以免被恶意获取到。</span>
                                </Box>
                                {(sendSmsUrl && mobilePathKey && sendSmsUrl == defSendSmsUrl) && <Box><a target="_blank" onClick={onMobilePathKeyClick} href={`${readSmsUrl}/?k=${mobilePathKey}`}>打开访问路径</a>
                                <span>{`${readSmsUrl}/?k=${mobilePathKey}`}</span></Box>}
                            </Box>
                            <Box>
                                <TextField
                                    id="editable-text"
                                    aria-label="editable-text"
                                    required
                                    fullWidth
                                    multiline
                                    placeholder={defMobilePathKey}
                                    variant="standard"
                                    value={mobilePathKey} onChange={(e) => onMobilePathKeyChange(e.target.value)} />
                            </Box>
                        </Stack>
                        <Box>
                            <Box>因为没时间开发，所以默认发送信息和邮件是我们申请的免费资源用来测试的，额度不多，大家都用的话，很快就会用完，用完后就所有人都发不出去了，如果出现这种情况，您可以自己申请或建设您自己的转发渠道。</Box>
                            <Box>如果该功能受欢迎，我们也会很快自己开发提供无限量免费使用资源。</Box>
                        </Box>
                        <Stack sx={{ border: "1px solid #ccc", borderRadius: 1, p: 1 }} direction={"column"}
                            spacing={1}>
                            <Box><b>邮件转发</b></Box>
                            <Box>
                                <span>
                                    我们默认是用<a onClick={onResendClick} href={resendUrl} target="_blank">resend</a>发送邮件的，您可以到它的官网申请自己的账号使用。
                                </span>
                            </Box>
                            <Box>
                                <TextField
                                    error={!testResendAuth(resendAuth)}
                                    id="editable-text"
                                    aria-label="editable-text"
                                    required
                                    fullWidth
                                    multiline
                                    helperText={testResendAuth(resendAuth) ? "请输入您要转发邮件的auth" : "您输入的auth可能不正确"}
                                    variant="standard"
                                    value={resendAuth} onChange={(e) => onResendAuthChange(e.target.value)} />
                            </Box>
                        </Stack>
                        <Stack sx={{ border: "1px solid #ccc", borderRadius: 1, p: 1 }} direction="column" spacing={1}>
                            <Box>
                                <Box><b>短信转发地址</b></Box>
                                <Box>
                                    <span>默认为：{defSendSmsUrl}</span>
                                </Box>
                                <Box>
                                    <span>
                                        如果您是自己使用，可以在<a onClick={onUpstashButtonClick} href="https://console.upstash.com/" target="_blank">upstash</a>申请免费redis进行操作即可。
                                    </span>
                                </Box>
                                <Box>
                                    <span>您还可以做一个代理层，在<a onClick={onCfButtonClick} href="https://cloudflare.com" target="_blank">cloudflare</a>网站创建worker，然后将worker的url填到这里。</span>
                                </Box>
                                <Box>
                                    <span>您也可以自建服务器或者使用钉钉、server酱等接收消息推送的api。</span>
                                </Box>
                            </Box>
                            <TextField
                                error={!testUrl(sendSmsUrl)}
                                id="editable-text"
                                aria-label="editable-text"
                                required
                                fullWidth
                                multiline
                                helperText={testUrl(sendSmsUrl) ? "请输入您要转发短信的url" : "您输入的url不合法"}
                                variant="standard"
                                value={sendSmsUrl} onChange={(e) => onSendSmsUrlChange(e.target.value)} />
                        </Stack>
                    </Stack>
                    {/* </Paper> */}
                </Dialog>
            </Box>
        </>
    )
}
